import 'url-search-params-polyfill';
import i18next from 'i18next';
import * as enLang from './translations/en';
import * as ukLang from './translations/uk';
import * as ruLang from './translations/ru';
import * as roLang from './translations/ro';
import * as plLang from './translations/pl';

const urlParams = new URLSearchParams(window.location.search);
const lang = urlParams.get('lang');

i18next.init({
	interpolation: { escapeValue: false, },
	lng: lang || 'en',
	resources: {
		en: {
			translation: enLang.default,
		},
		uk: {
			translation: ukLang.default,
		},
		ru: {
			translation: ruLang.default,
		},
		ro: {
			translation: roLang.default,
		},
		pl: {
			translation: plLang.default,
		},
	},
});

export default i18next;